import * as jQuery from 'jquery';
import {
    mobileRegExp,
    tabletRegExp
} from './utils/regex';

const jQueryString = 'jQuery';
const $String = '$';
global[jQueryString] = jQuery;
global[$String] = jQuery;

const agent = navigator.userAgent || navigator.vendor || window.opera;
window.isMobile = () => mobileRegExp.test(agent) || tabletRegExp.test(agent.substr(0, 4));
